import type { QuickNoteSummary } from "@/types/quick-note";

import { listQuickNotes } from "./quick-note";

export const quickNoteQueryKeys = {
  all: ["user", "patient", "quick-notes"] as const,
  list: (patientId: string) => [...quickNoteQueryKeys.all, patientId] as const,
};

export const quickNoteQueryOptions = {
  list: (patientId: string) => ({
    queryKey: quickNoteQueryKeys.list(patientId),
    queryFn: () => listQuickNotes(patientId),
    select: (data: QuickNoteSummary[] | null) => data ?? [],
  }),
};
